import { OnInit, Component, ViewChild } from '@angular/core';
import { DatatableComponent, SelectionType } from '@swimlane/ngx-datatable';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { IResult } from 'app/shared/models/result.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ValidatorService } from 'app/shared/services/validator.service';
import { SnotifyService } from 'ng-snotify';
import { IdentityService } from '../identity.service';
import { AppConfig } from 'app/app.config';
import { IDtoSystem } from 'app/shared/models/security/dto-system.model';
import { ModalSystemModuleComponet } from 'app/views/modales/security/system-module/modal-system-module.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

@Component({
    selector: 'app-system',
    styleUrls: ['./system.style.scss'],
    templateUrl: 'system.template.html'
})
export class SystemComponent implements OnInit {
    /**Modales */
    private modalRef: BsModalRef;
    private configModal = {
        backdrop: true,
        ignoreBackdropClick: true,
        keyboard: false,
    };
    /**Validadores */
    private validator = ValidatorService;
    private fsaFlags = [false];
    private errorMessages: any;
    /**Formularios */
    private formSystem: FormGroup;
    /**Variable de trasporte de datos */
    private result: IResult;
    /**Notificaciones */
    private configToast: any;
    /**Variables */
    private now: number;
    SelectionType = SelectionType;
    /**Listas */
    private systems = new Array() as IDtoSystem[];
    /** Tablas*/
    @ViewChild(DatatableComponent, { static: false }) tableSystems: DatatableComponent;
    public constructor(private configurationService: ConfigurationService
        , private spinner: NgxSpinnerService
        , private formBuilder: FormBuilder
        , private modalService: BsModalService
        , public snotifyService: SnotifyService
        , private identityService: IdentityService
        , private configGeneral: AppConfig) {
        this.initializeFormSystem();
        this.configToast = this.configGeneral.getConfigToast();
    }
    ngOnInit(): void {
        this.now = Date.now();
        if (this.configurationService.isReady) {
            this.spinner.show();
            this.getSystems();
        } else {
            this.configurationService.settingsLoaded$.subscribe(x => {
                this.spinner.show();
                this.getSystems();
            });
        }
    }
    private initializeFormSystem() {
        this.formSystem = this.formBuilder.group({
            name: [null, Validators.required]
        });
    }
    private getSystems(): void {
        this.identityService.getSystems()
            .subscribe(
                (x) => {
                    this.systems = x.data as IDtoSystem[];
                    this.spinner.hide();
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    private save(): void {
        if (!this.formSystem.valid) {
            this.snotifyService.error('Ingrese un nombre para el sistema'
                , 'Error', this.configToast);
            return;
        }
        const data = this.formSystem.value;
        this.identityService.addSystem(data)
            .subscribe(
                (x) => {
                    if (this.configGeneral.notificationSuccessError(x)) {
                        this.formSystem.reset();
                        this.getSystems();
                    }
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    private openModalSystemModule(item: any) {
        const initialState = {
            system: item,
            title: `Asignación de modulos al sistema ${item.name}`
        };
        this.modalRef = this.modalService.show(ModalSystemModuleComponet
            , Object.assign({ initialState }
                , { class: 'modal-lg' }
                , this.configModal));
        this.modalRef.content.onClose.subscribe((result) => {

        });
    }
}
